import React, { useState } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Link } from "react-router-dom";
import faqBanner from "../../Images/student-services/ragging.webp";
import classroomImage from "../../Images/gov-body/rules.webp";
import { Row } from "react-bootstrap";

const body = [
    { name: "Dr. Sandeep Sahu, DSW", remarks: "Convener" },
    { name: "Dr. N.K Swamy, Director IQAC", remarks: "Member Secretary" },
    { name: "Mr. Preetam Sahu, Asst. Prof. Faculty of Arts & Humanities", remarks: "Member" },
    { name: "Mr. Gokul Prasad Sahu, Asst. Prof. Faculty of Science", remarks: "Member" },
    { name: "Dr. Garima Diwan, Associate Prof. Faculty of Arts & Humanities", remarks: "Member" },
    { name: "Dr. Poonam Verma, Asst. Prof. Faculty of Science", remarks: "Member" },
    { name: "Mr. Rameshwar Nishad, Asst. Prof. Faculty of Science", remarks: "Liaison officer for OBC Cell (nominated by Vice Chancellor)" },
    { name: "Mr. Ram Krishna Deshmukh, Asst. Prof. Faculty of Science", remarks: "Liaison officer for OBC Cell (nominated by Vice Chancellor)" }
];

const OtherBackward = () => {
    return (
        <>
            <title>ISBM University – OBC Committee for Student Welfare</title>
            <meta
                name="description"
                content="The OBC Committee at ISBM University supports students through awareness, scholarships, rights education, and grievance redressal for inclusive growth."
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${faqBanner})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content">
                            <h1>Other Backward Class Committee</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <Link to="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active text-white" aria-current="page">
                                    Other Backward Class Committee
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="bg-light">
                <div className="container-xxl ptb-50">
                    <Row className="m-0">
                        <div className="col-md-6">
                            <h2 className="modern-title text-blue">Other Backward Class (OBC) Committee</h2>
                            <div className="underline-divider mb-3"></div>
                            <p className="text-muted">
                                ISBM University is dedicated to promoting social equity and inclusive education.
                                To support students from the Other Backward Class (OBC) category, the university
                                has formed an OBC Committee that ensures fair treatment and equal opportunities
                                in academic, administrative, and extracurricular areas. The committee addresses
                                grievances, monitors implementation of reservation policies, and ensures a
                                discrimination-free environment.
                            </p>
                            <p className="text-muted">
                                The OBC Committee also works to create awareness among students about their rights,
                                available scholarships, and welfare schemes. Through regular meetings, counseling,
                                and support initiatives, ISBM University strives to empower OBC students and help
                                them achieve their academic and professional goals with confidence and dignity.
                            </p>
                        </div>
                        <div className="col-md-6">
                            <div className="governing-image-wrapper shadow">
                                <img src={classroomImage} alt="Governing Body" />
                            </div>
                        </div>
                    </Row>
                </div>
            </section>

            <section className="visa-section py-5 bg-light">
                <div className="container-xxl">
                    <h2 className="text-center modern-title text-blue">Other Backward Class Committee</h2>
                    <div className="underline-center mb-5 mx-auto"></div>
                    <div className="row m-0">
                        {body.map((member, index) => (
                            <div className="col-lg-4 col-md-6 d-flex mb-3" key={index}>
                                <div className="visa-box p-4 shadow w-100 h-100 d-flex flex-column">
                                    <div className="visahead">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <h5 className="text-dark mb-0">{member.name}</h5>
                                            <span className="badge designation ms-2 ">
                                                {member.designation}
                                            </span>
                                        </div>
                                        <div className="underlinetwo"></div>
                                    </div>
                                    <ul className="mb-0 list-unstyled">
                                        <li>{member.remarks}</li>
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default OtherBackward;
